module.exports = __webpack_public_path__ + "static/kv-dfc2a385769e0aea335ce2f5ddd66b29.jpg";